import './footer.scss'
import { EventBus } from 'js/utility/event-bus.js'

export default {
    name: 'footer',

    methods: {
        loginForm (form) {
            EventBus.$emit('ModalForm.toggle', form)
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/footer/footer.js